import { RootState } from '../rootReducer';
import { News } from './actions';

export const getNewsState = (state: RootState): News => state.news;
